const linkRouter = [
  {
    path: '/link/:id(\\d+)',
    name: 'LinkDetail',
    component: () => import('@/views/link/detail')
  }
]

export default linkRouter



// WEBPACK FOOTER //
// ./src/router/modules/link.js